/**
 * 创建人：但志强
 * 时间：2019-6-11
 * 描述：将bool值转换成 启用和禁用
 * 更新记录: 
 */
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

/**
 * 将布尔值转换成 启用 禁用
 * @example <td [innerHTML]="data.isPublish | enableOrDisabled"></td>
 */
@Pipe({
  name: 'enableOrDisabled'
})
export class EnableOrDisabledPipe implements PipeTransform {
  //获取当前dom节点
  constructor(private dom: DomSanitizer){}

  /**
   * 管道的初始化方法
   * @param value 传入的数据 true 或者f alse
   */
  transform(value: boolean | number |any ): any {
    if(+value){
      //表面该HTML是可信赖的
      return this.dom.bypassSecurityTrustHtml(`<span class="state-success">启用</span>`);
    } else {
      return this.dom.bypassSecurityTrustHtml(`<span class="state-error">禁用</span>`);
    }
  }

}
//前台写法
//<td [innerHTML]="data.isPublish | enableOrDisabled"></td>